import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';

import { DeviceMode } from '@common/types/layout.type';

import { ThemeSettings } from '@sites/site-theme/src/enums/theme-settings.enum';
import { ThemeStateService } from '@sites/site-theme/src/state';

import { SpThemeButtonsSettingsComponent } from './buttons-settings/buttons-settings.component';
import { SpThemeColorsSettingsComponent } from './colors-settings/colors-settings.component';
import { SpThemeFontsSettingsComponent } from './fonts-settings/fonts-settings.component';
import { SpThemePresetSettingsComponent } from './preset-settings/preset-settings.component';

/**
 * The theme drawer: whichever settings panel is open, or the preset strip when none is.
 *
 * The four panels used to be picked by a second component that built them imperatively —
 * `ViewContainerRef.createComponent` off a `Record<any, any>` map, with a hand-written `setInput`
 * and a manual `subscribe` for the one panel that takes an input and emits. A template switch does
 * the same construction and destruction, and the compiler checks the binding it was doing by hand.
 */
@Component({
    selector: 'sp-themes',
    templateUrl: './themes.component.html',
    styleUrls: ['./themes.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        SpThemeColorsSettingsComponent,
        SpThemeButtonsSettingsComponent,
        SpThemeFontsSettingsComponent,
        SpThemePresetSettingsComponent,
    ],
})
export class SpThemesComponent {
    private readonly themeState = inject(ThemeStateService);

    public readonly deviceMode = input<DeviceMode>(DeviceMode.desktop);
    public readonly changeDeviceMode = output<DeviceMode>();

    public readonly ThemeSettings = ThemeSettings;
    public readonly themeConfigLoaded = this.themeState.loaded;
    public readonly activeThemeSetting = this.themeState.activeSetting;
}
